import { formatRupiah, normHouseKey, sget } from "./utils/format";
import { RAW_HOUSES } from "./data/houses";
import {
  TARIF_IPL_BULANAN,
  REKENING_BENDAHARA,
  BULAN,
  TAHUN_AWAL,
  TAHUN_LIST
} from "./config/appConfig"

import LaporanTab from "./LaporanTab";
import LaporanTunggakanTab from "./LaporanTunggakanTab";
import LoginScreen from "./components/LoginScreen";
import StatusBadge from "./components/StatusBadge";
import React, { useState, useEffect, useRef, useCallback } from "react";
import { supabase } from "./supabaseClient";
import imageCompression from "browser-image-compression";
import { buildResidentFromDefaultData } from "./utils/residentData";
import { filterPaymentRecordsForHouse, isPaymentRecordForHouse, normalizeHouseNo } from "./utils/paymentData";

async function sset(key, val){
  if(!window.storage || !window.storage.set) {
    localStorage.setItem(key, JSON.stringify(val));
    return true;
  }
  try {
    const r = await window.storage.set(key, JSON.stringify(val), true);
    return !!r;
  } catch(e) { return false; }
}

// === Cache PIN lokal (fallback jika Supabase RLS memblokir SELECT) ===
function pinCacheKey(nomor_rumah) {
  return "pin:" + String(nomor_rumah || "").trim().toUpperCase();
}
async function getCachedPin(nomor_rumah) {
  return await sget(pinCacheKey(nomor_rumah));
}
async function setCachedPin(nomor_rumah, pin) {
  await sset(pinCacheKey(nomor_rumah), String(pin || "").trim());
}

const styles = {
  app: { minHeight:"100vh", width:"100%", background:"linear-gradient(180deg, #F8FAF6 0%, #EBF5ED 50%, #ffffff 100%)", fontFamily:"'Inter', 'Segoe UI', sans-serif", color:"#1E2A22", display:"flex", flexDirection:"column", position:"relative" },
  centerScreen: { minHeight:"100vh", width:"100%", display:"flex", alignItems:"center", justifyContent:"center", background:"linear-gradient(135deg, #F8FAF6 0%, #EBF5ED 40%, #ffffff 100%)", padding:"16px", boxSizing:"border-box", position:"relative", overflow:"hidden" },
  card: { width:"100%", maxWidth:"440px", background:"rgba(255, 255, 255, 0.95)", backdropFilter:"blur(24px)", WebkitBackdropFilter:"blur(24px)", borderRadius:"24px", padding:"36px 28px", boxShadow:"0 20px 60px rgba(30, 86, 49, 0.12), inset 0 1px 0 rgba(255,255,255,0.6)", border:"1px solid rgba(30, 86, 49, 0.12)", boxSizing:"border-box", margin:"0 auto" },
  input: { width:"100%", padding:"15px 16px", fontSize:"16px", border:"1.5px solid rgba(30, 86, 49, 0.15)", borderRadius:"12px", marginBottom:"14px", boxSizing:"border-box", background:"#ffffff", color:"#1E2A22", transition:"all 0.3s ease" },
  btnPrimary: { width:"100%", padding:"15px", fontSize:"16px", fontWeight:"700", letterSpacing:"0.5px", color:"#ffffff", background:"linear-gradient(135deg, #1E5631 0%, #2E7D32 100%)", border:"none", borderRadius:"12px", cursor:"pointer", boxShadow:"0 4px 20px rgba(30, 86, 49, 0.3), 0 4px 20px rgba(46, 125, 50, 0.2)", transition:"all 0.3s ease" },
  btnGhost: { width:"100%", padding:"13px", fontSize:"15px", fontWeight:"700", color:"#1E5631", background:"rgba(30, 86, 49, 0.06)", border:"1.5px solid rgba(30, 86, 49, 0.25)", borderRadius:"12px", cursor:"pointer", marginTop:"10px", transition:"all 0.3s ease" },
  header: { background:"rgba(255, 255, 255, 0.9)", backdropFilter:"blur(20px)", WebkitBackdropFilter:"blur(20px)", color:"#1E2A22", padding:"16px 20px", position:"sticky", top:0, zIndex:5, borderBottom:"1px solid rgba(30, 86, 49, 0.12)" },
  tabbar: { display:"flex", background:"rgba(255, 255, 255, 0.95)", backdropFilter:"blur(20px)", WebkitBackdropFilter:"blur(20px)", borderTop:"1px solid rgba(30, 86, 49, 0.12)", position:"fixed", bottom:0, left:0, right:0, zIndex:100, boxShadow:"0 -8px 32px rgba(30, 86, 49, 0.08)", height:"72px", alignItems:"center", justifyContent:"space-around" },
  tabBtn: (active)=>({ flex:1, height:"100%", padding:"6px 2px", textAlign:"center", fontSize:"12px", color:active?"#1E5631":"#8A8F86", background:"transparent", border:"none", fontWeight:"bold", cursor:"pointer", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", gap:"3px", transition:"all 0.3s ease" }),
  content: { flex:1, padding:"20px 16px 30px", overflowY:"auto" },
  bioRow: { display:"flex", justifyContent:"space-between", padding:"14px 0", borderBottom:"1px solid rgba(30, 86, 49, 0.08)", fontSize:"16px" },
  bioLabel: { color:"#5A6059" },
  bioVal: { fontWeight:"bold", color:"#1E2A22", textAlign:"right" },
  infoBox: { background:"rgba(30, 86, 49, 0.06)", padding:"16px", borderRadius:"14px", marginBottom:"14px", fontSize:"15px", border:"1px solid rgba(30, 86, 49, 0.1)", borderLeft:"4px solid #1E5631", lineHeight:"1.5" },
  badgeTrial: { background:"rgba(245, 158, 11, 0.1)", color:"#B45309", padding:"12px 14px", borderRadius:"12px", marginBottom:"16px", fontSize:"14px", fontWeight:"bold", border:"1px solid rgba(245, 158, 11, 0.3)", lineHeight:"1.4" },
  btn3D: (bgColor, shadowColor, textColor) => ({
    textAlign:"center", border:"1px solid rgba(30, 86, 49, 0.08)", cursor:"pointer", borderRadius:"16px", padding:"20px 14px", background:"rgba(255, 255, 255, 0.8)", backdropFilter:"blur(12px)", WebkitBackdropFilter:"blur(12px)", color:textColor, boxShadow:"0 8px 24px rgba(30, 86, 49, 0.08), inset 0 1px 0 rgba(255,255,255,0.5)", transition:"all 0.3s cubic-bezier(0.4, 0, 0.2, 1)", marginBottom:"4px"
  }),
  waButton: { background:"linear-gradient(135deg, #25D366 0%, #128C7E 100%)", color:"#fff", border:"none", borderRadius:"10px", padding:"8px 16px", fontSize:"13px", fontWeight:"bold", cursor:"pointer", textDecoration:"none", display:"inline-flex", alignItems:"center", gap:"4px", boxShadow:"0 4px 12px rgba(37, 211, 102, 0.3)" }
};

// DIKUNCI: Ikon grafis panah kembali asli
function IconPanahBackSVG() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round">
      <line x1="19" y1="12" x2="5" y2="12" />
      <polyline points="12 19 5 12 12 5" />
    </svg>
  );
}

function LogoRumahSVG() {
  return (
    <svg width="110" height="110" viewBox="0 0 100 100" style={{ marginBottom:"10px", filter:"drop-shadow(0 0 16px rgba(30, 86, 49, 0.25))" }}>
      <defs>
        <linearGradient id="logoGradApp" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#1E5631" />
          <stop offset="50%" stopColor="#2E7D32" />
          <stop offset="100%" stopColor="#4CAF50" />
        </linearGradient>
      </defs>
      <circle cx="50" cy="50" r="46" fill="rgba(30, 86, 49, 0.06)" stroke="url(#logoGradApp)" strokeWidth="2" />
      <rect x="35" y="48" width="30" height="28" rx="2" fill="url(#logoGradApp)" />
      <rect x="47" y="60" width="6" height="16" fill="#ffffff" opacity="0.9" />
      <rect x="39" y="53" width="5" height="5" rx="1" fill="#ffffff" opacity="0.8" />
      <rect x="56" y="53" width="5" height="5" rx="1" fill="#ffffff" opacity="0.8" />
      <polygon points="50,28 31,49 69,49" fill="#4CAF50" opacity="0.9" />
    </svg>
  );
}


function ChangePasswordScreen({ onChange }){
  const [p1, setP1] = useState("");
  const [p2, setP2] = useState("");
  const [err, setErr] = useState("");
  const submit = async (e)=>{
    e.preventDefault();
    if(p1.length < 4){ setErr("Password minimal 4 karakter."); return; }
    if(p1 !== p2){ setErr("Konfirmasi password tidak sama."); return; }
    setErr("");
    await onChange(p1);
  };
  return (
    <div style={styles.centerScreen}>
      <div style={styles.card} className="fade-in-up">
        <div style={{fontSize:"22px", fontWeight:"800", marginBottom:"8px", background:"linear-gradient(135deg, #1E5631 0%, #2E7D32 100%)", WebkitBackgroundClip:"text", WebkitTextFillColor:"transparent", backgroundClip:"text"}}>Buat Password Baru</div>
        <div style={{fontSize:"14px", color:"#5A6059", marginBottom:"20px"}}>Keamanan akun Anda dengan password baru</div>
        <form onSubmit={submit}>
          <input style={styles.input} className="futuristic-input" type="password" placeholder="Password baru" value={p1} onChange={e=>setP1(e.target.value)} />
          <input style={styles.input} className="futuristic-input" type="password" placeholder="Ulangi password baru" value={p2} onChange={e=>setP2(e.target.value)} />
          {err && <div style={{color:"#C24C4C", fontSize:"13.5px", fontWeight:"600", marginBottom:"12px", padding:"10px 14px", background:"rgba(194, 76, 76, 0.08)", borderRadius:"10px", border:"1px solid rgba(194, 76, 76, 0.25)"}}>{err}</div>}
          <button style={styles.btnPrimary} className="neon-btn" type="submit">Simpan Password</button>
        </form>
      </div>
    </div>
  );
}

function ProfilTab({ house, onRequestChangePassword }){
  return (
    <div style={{paddingBottom:"20px"}}>
      <div style={{background:"linear-gradient(135deg, rgba(30, 86, 49, 0.12) 0%, rgba(46, 125, 50, 0.12) 100%)", color:"#1E2A22", borderRadius:"20px", padding:"24px", marginBottom:"18px", boxShadow:"0 8px 32px rgba(30, 86, 49, 0.1)", border:"1px solid rgba(30, 86, 49, 0.15)", backdropFilter:"blur(12px)", WebkitBackdropFilter:"blur(12px)"}}>
        <div style={{fontSize:"13px", color:"#1E5631", marginBottom:"6px", fontWeight:"600", letterSpacing:"0.5px"}}>PROFIL WARGA</div>
        <div style={{fontSize:"22px", fontWeight:"800", marginTop:"4px", lineHeight:"1.3", background:"linear-gradient(135deg, #1E5631 0%, #2E7D32 100%)", WebkitBackgroundClip:"text", WebkitTextFillColor:"transparent", backgroundClip:"text"}}>Bpk/Ibu {house.nama}</div>
        <div style={{fontSize:"15px", marginTop:"8px", color:"#5A6059"}}>Nomor rumah: <strong style={{color:"#1E2A22"}}>{house.nomor_rumah}</strong></div>
      </div>
      <div style={{background:"rgba(255, 255, 255, 0.8)", backdropFilter:"blur(12px)", WebkitBackdropFilter:"blur(12px)", borderRadius:"16px", padding:"18px", marginBottom:"18px", border:"1px solid rgba(30, 86, 49, 0.08)", borderLeft:"4px solid #1E5631"}}>
        <div style={{fontSize:"15px", color:"#5A6059"}}>Tarif Bulanan Resmi: <strong style={{fontSize:"18px", color:"#1E5631"}}>{formatRupiah(TARIF_IPL_BULANAN)}</strong></div>
      </div>
      <div style={{background:"rgba(255, 255, 255, 0.8)", backdropFilter:"blur(12px)", WebkitBackdropFilter:"blur(12px)", borderRadius:"16px", padding:"8px 18px", marginBottom:"14px", border:"1px solid rgba(30, 86, 49, 0.08)"}}>
        <div style={styles.bioRow}><span style={styles.bioLabel}>Nomor rumah</span><span style={styles.bioVal}>{house.nomor_rumah}</span></div>
        <div style={styles.bioRow}><span style={styles.bioLabel}>Nama pemilik/penghuni</span><span style={styles.bioVal}>{house.nama}</span></div>
        <div style={styles.bioRow}>
          <span style={styles.bioLabel}>Nomor HP</span>
          <span style={styles.bioVal}>{house.no_hp || "-"}</span>
        </div>
        <div style={{marginTop:14}}>
          <button type="button" onClick={onRequestChangePassword} style={{...styles.btnGhost, width:"100%"}} className="neon-btn">Ganti Password</button>
        </div>
      </div>
    </div>
  );
}

function PembayaranTab({ house, listPembayaranSupabase, refreshPayData }){
  const [tahun, setTahun] = useState(new Date().getFullYear());
  const [openBulan, setOpenBulan] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const fileRef = useRef(null);

  const handleRefresh = async () => {
    setIsRefreshing(true);
    await refreshPayData();
    setIsRefreshing(false);
  };

  const getStatus = (bulanIdx)=>{
    const namaBulanTarget = BULAN[bulanIdx];
    const transaksi = (listPembayaranSupabase || []).find(
      (p) => (p.bulan || "").trim().toLowerCase() === namaBulanTarget.trim().toLowerCase() && String(p.tahun) === String(tahun)
    );
    if (!transaksi) return "belum";
    return transaksi.status ? String(transaksi.status).trim() : "belum";
  };

  const dapatkanProofFoto = (bulanIdx) => {
    const namaBulanTarget = BULAN[bulanIdx];
    const transaksi = (listPembayaranSupabase || []).find(
      (p) => (p.bulan || "").trim().toLowerCase() === namaBulanTarget.trim().toLowerCase() && String(p.tahun) === String(tahun)
    );
    return transaksi ? transaksi.bukti_foto : null;
  };

  const handleFile = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploading(true);
    try {
      const options = { maxSizeMB: 0.2, maxWidthOrHeight: 800, useWebWorker: true };
      const compressedFile = await imageCompression(file, options);
      const fileExt = file.name.split('.').pop();
      const fileName = `${house.nomor_rumah.replace('/', '-')}_${Date.now()}_struk.${fileExt}`;

      const { error: storageError } = await supabase.storage.from('bukti_transfer').upload(fileName, compressedFile);
      if (storageError) throw storageError;

      const { data: urlData } = supabase.storage.from('bukti_transfer').getPublicUrl(fileName);

      // Cek apakah pembayaran bulan ini sudah ada
      // Gunakan filter .eq() agar tidak diblokir RLS (sebelumnya query tanpa filter
      // menyebabkan existingRows kosong, lalu INSERT gagal karena duplicate key)
      const { data: existingRows } = await supabase
        .from('pembayaran')
        .select('id,status,nomor_rumah,bulan,tahun')
        .eq('nomor_rumah', house.nomor_rumah)
        .eq('bulan', BULAN[openBulan])
        .eq('tahun', tahun.toString());

      // Filter tambahan di sisi JS untuk toleransi perbedaan format (spasi/huruf)
      const existing = (existingRows || []).filter((row) => {
        const isSameHouse = normalizeHouseNo(row.nomor_rumah) === normalizeHouseNo(house.nomor_rumah);
        const isSameMonth = normalizeHouseNo(row.bulan) === normalizeHouseNo(BULAN[openBulan]);
        const isSameYear = String(row.tahun) === String(tahun);
        return isSameHouse && isSameMonth && isSameYear;
      });

      if (existing.length > 0) {
        const existingRecord = existing[0];
        // Jika sudah lunas, tolak upload ulang
        if (String(existingRecord.status || "").toLowerCase().includes("lunas")) {
          throw new Error(
            `Pembayaran ${BULAN[openBulan]} ${tahun} sudah lunas dan tidak dapat diubah.`
          );
        }
        // Sudah ada record (Pending/Menunggu) → UPDATE bukti_foto & status
        const { error: updateError } = await supabase
          .from('pembayaran')
          .update({
            bukti_foto: urlData.publicUrl,
            status: 'Pending'
          })
          .eq('id', existingRecord.id);

        if (updateError) throw updateError;
      } else {
        // Belum ada record → INSERT baru
        const { error: dbError } = await supabase
          .from('pembayaran')
          .insert([
            {
              nomor_rumah: house.nomor_rumah,
              nama_warga: house.nama || "",
              bulan: BULAN[openBulan],
              tahun: tahun.toString(),
              status: 'Pending',
              bukti_foto: urlData.publicUrl
            }
          ]);

        // Fallback: jika INSERT gagal karena duplicate key (record sebenarnya
        // sudah ada tapi tidak terbaca oleh SELECT), coba UPDATE
        if (dbError) {
          const errMsg = String(dbError.message || "");
          if (errMsg.includes("duplicate key") || dbError.code === "23505") {
            const { error: updateError2 } = await supabase
              .from('pembayaran')
              .update({
                bukti_foto: urlData.publicUrl,
                status: 'Pending'
              })
              .eq('nomor_rumah', house.nomor_rumah)
              .eq('bulan', BULAN[openBulan])
              .eq('tahun', tahun.toString());

            if (updateError2) throw updateError2;
          } else {
            throw dbError;
          }
        }
      }

      await refreshPayData();
      setOpenBulan(null);
    } catch (err) {
      alert("Gagal: " + err.message);
    }
    setUploading(false);
  };

  return (
    <div>
      <div style={{display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:"20px", gap:"10px"}}>
        <button type="button" onClick={()=>setTahun(t=>Math.max(TAHUN_AWAL, t-1))} style={{border:"1px solid rgba(30, 86, 49, 0.15)", background:"rgba(255, 255, 255, 0.8)", backdropFilter:"blur(12px)", WebkitBackdropFilter:"blur(12px)", borderRadius:"12px", width:"44px", height:"44px", fontSize:"22px", fontWeight:"bold", color:"#1E5631", cursor:"pointer"}}>‹</button>
        <div style={{fontSize:"21px", fontWeight:"800", background:"linear-gradient(135deg, #1E5631 0%, #2E7D32 100%)", WebkitBackgroundClip:"text", WebkitTextFillColor:"transparent", backgroundClip:"text"}}>Tahun {tahun}</div>
        <button type="button" onClick={()=>setTahun(t=>Math.min(TAHUN_LIST[TAHUN_LIST.length-1], t+1))} style={{border:"1px solid rgba(30, 86, 49, 0.15)", background:"rgba(255, 255, 255, 0.8)", backdropFilter:"blur(12px)", WebkitBackdropFilter:"blur(12px)", borderRadius:"12px", width:"44px", height:"44px", fontSize:"22px", fontWeight:"bold", color:"#1E5631", cursor:"pointer"}}>›</button>
        <button type="button" onClick={handleRefresh} disabled={isRefreshing} style={{border:"none", background:"linear-gradient(135deg, #1E5631 0%, #2E7D32 100%)", color:"#ffffff", borderRadius:"10px", padding:"8px 14px", fontSize:"13px", fontWeight:"bold", cursor:isRefreshing ? "not-allowed" : "pointer", opacity:isRefreshing ? 0.7 : 1, boxShadow:"0 4px 12px rgba(30, 86, 49, 0.2)"}}>🔄 {isRefreshing ? "Memuat..." : "Refresh"}</button>
      </div>
      <div style={{display:"grid", gridTemplateColumns:"1fr 1fr", gap:"14px", paddingBottom:"20px"}}>
        {BULAN.map((nama, idx)=>{
          const status = getStatus(idx);
          let config = { bg: "rgba(30, 86, 49, 0.06)", shadow: "rgba(30, 86, 49, 0.15)", text: "#1E5631" }; 
          if (status.toLowerCase().includes("menunggu")) config = { bg: "rgba(245, 158, 11, 0.06)", shadow: "rgba(245, 158, 11, 0.15)", text: "#B45309" };
          if (status === "belum") config = { bg: "rgba(194, 76, 76, 0.06)", shadow: "rgba(194, 76, 76, 0.15)", text: "#C24C4C" };
          
          return (
            <button key={idx} type="button" onClick={()=>setOpenBulan(idx)} style={styles.btn3D(config.bg, config.shadow, config.text)} className="neon-btn">
              <div style={{fontSize:"16px", fontWeight:"bold"}}>{nama}</div>
              <div style={{marginTop:"8px"}}><StatusBadge status={status} /></div>
            </button>
          );
        })}
      </div>
      {openBulan !== null && (() => {
        const status = getStatus(openBulan);
        const proof = dapatkanProofFoto(openBulan);
        const canUpload = status === "belum" || (status.toLowerCase().includes("pending") || status.toLowerCase().includes("menunggu"));
        
        return (
          <div style={{position:"fixed", inset:0, background:"rgba(30, 86, 49, 0.4)", backdropFilter:"blur(8px)", WebkitBackdropFilter:"blur(8px)", display:"flex", alignItems:"flex-end", justifyContent:"center", zIndex:200}} onClick={()=>setOpenBulan(null)}>
            <div onClick={e=>e.stopPropagation()} className="slide-up" style={{background:"rgba(255, 255, 255, 0.98)", backdropFilter:"blur(24px)", WebkitBackdropFilter:"blur(24px)", borderRadius:"24px 24px 0 0", padding:"28px 20px 32px", width:"100%", maxWidth:"480px", border:"1px solid rgba(30, 86, 49, 0.15)", borderTop:"1px solid rgba(30, 86, 49, 0.2)"}}>
              <div style={{fontSize:"20px", fontWeight:"800", color:"#1E5631", marginBottom:"6px"}}>{BULAN[openBulan]} {tahun}</div>
              <div style={{marginBottom:"16px"}}><StatusBadge status={status} /></div>
              
              {status === "belum" && (
                <div style={styles.infoBox}>
                  <div style={{fontWeight:"bold", marginBottom:"8px", color:"#1E5631"}}>Transfer ke rekening:</div>
                  <div style={{color:"#1E2A22"}}>{REKENING_BENDAHARA.bank} : <strong>{REKENING_BENDAHARA.nomor}</strong></div>
                  <div style={{color:"#1E2A22"}}>A.n : <strong>{REKENING_BENDAHARA.atas_nama}</strong></div>
                  <div style={{marginTop:"8px", color:"#1E2A22"}}>Jumlah: <strong style={{color:"#1E5631"}}>{formatRupiah(TARIF_IPL_BULANAN)}</strong></div>
                </div>
              )}
              
              {proof && <img src={proof} alt="bukti" style={{width:"100%", maxHeight:"180px", objectFit:"contain", borderRadius:"12px", marginBottom:"14px", border:"1px solid rgba(30, 86, 49, 0.08)"}} />}
              
              {canUpload && (
                <div style={{marginBottom:"14px"}}>
                  <input ref={fileRef} type="file" accept="image/*" onChange={handleFile} style={{display:"none"}} />
                  <button type="button" onClick={()=>fileRef.current && fileRef.current.click()} disabled={uploading} style={{...styles.btnPrimary, marginBottom:"10px"}} className="neon-btn">
                    {uploading ? "📤 Mengunggah..." : proof ? "📷 Ganti Bukti Transfer" : "📤 Upload Bukti Transfer"}
                  </button>
                  {status !== "belum" && (
                    <div style={{fontSize:"12px", color:"#8A8F86", textAlign:"center", marginBottom:"10px"}}>
                      Pembayaran sudah diupload, menunggu verifikasi admin
                    </div>
                  )}
                </div>
              )}
              
              {status.toLowerCase().includes("lunas") && (
                <div style={{...styles.infoBox, background:"rgba(30, 86, 49, 0.06)", borderLeft:"4px solid #1E5631", marginBottom:"14px", color:"#1E5631"}}>
                  ✅ Pembayaran sudah dikonfirmasi oleh admin
                </div>
              )}
              
              <button type="button" onClick={()=>setOpenBulan(null)} style={styles.btnGhost} className="neon-btn">Tutup</button>
            </div>
          </div>
        );
      })()}
    </div>
  );
}

function IuranLainnyaTab({ house }) {
  const [jenisIuran, setJenisIuran] = useState("");
const [besarIuran, setBesarIuran] = useState("");
const [buktiFoto, setBuktiFoto] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [riwayat, setRiwayat] = useState([]);
  const [hiddenItems, setHiddenItems] = useState([]);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const fileInputRef = useRef(null);

  const hideItem = (itemId) => {
    setHiddenItems([...hiddenItems, itemId]);
  };

  const muatRiwayatIuranLainnya = useCallback(async () => {
    try {
      setIsRefreshing(true);
      const { data, error } = await supabase
        .from("iuran_lainnya")
        .select("*")
        .eq("nomor_rumah", house.nomor_rumah)
        .order("id", { ascending: false });
      
      if (error) throw error;
      setRiwayat(data || []);
  
    } catch (err) {
      console.error(err);
    } finally {
      setIsRefreshing(false);
    }
  }, [house.nomor_rumah]);

  useEffect(() => { 
    muatRiwayatIuranLainnya();

    // Subscribe to real-time updates for iuran_lainnya
    const targetHouse = house.nomor_rumah;
    const channel = supabase
      .channel(`iuran-${targetHouse}`)
      .on(
        "postgres_changes",
        { event: "*", schema: "public", table: "iuran_lainnya" },
        (payload) => {
          if (String(payload.new?.nomor_rumah || payload.old?.nomor_rumah).trim().toUpperCase() === String(targetHouse).trim().toUpperCase()) {
            muatRiwayatIuranLainnya();
          }
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [muatRiwayatIuranLainnya, house.nomor_rumah]);

  const handleUploadFile = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploading(true);
    try {
      const options = { maxSizeMB: 0.2, maxWidthOrHeight: 800, useWebWorker: true };
      const compressedFile = await imageCompression(file, options);
      const fileExt = file.name.split('.').pop();
      const fileName = `lainnya_${house.nomor_rumah.replace('/', '-')}_${Date.now()}.${fileExt}`;

      const { error: storageError } = await supabase.storage.from('bukti_transfer').upload(fileName, compressedFile);
      if (storageError) throw storageError;

      const { data: urlData } = supabase.storage.from('bukti_transfer').getPublicUrl(fileName);
      setBuktiFoto(urlData.publicUrl);
    } catch (err) { alert(err.message); }
    setUploading(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!besarIuran || !buktiFoto) {
      alert("Harap isi besar iuran dan unggah bukti transfer.");
      return;
    }
    try {
      let tName = "iuran_custom";
      const { error: checkErr } = await supabase.from(tName).select("id").limit(1);
      if (checkErr) tName = "iuran_lainnya";

      const { error } = await supabase.from(tName).insert([
        {nomor_rumah: house.nomor_rumah,
          nama_warga: house.nama || "",
          jenis_iuran: jenisIuran,
          nominal: parseFloat(besarIuran),
          bukti_transfer: buktiFoto,
          status: "Menunggu verifikasi"}
      ]);
      if (error) throw error;
      setBesarIuran("");
      setBuktiFoto(null);
      muatRiwayatIuranLainnya();
    } catch (err) { alert(err.message); }
  };

  return (
    <div>
      <div style={{fontSize:"18px", fontWeight:"800", marginBottom:"14px", background:"linear-gradient(135deg, #1E5631 0%, #2E7D32 100%)", WebkitBackgroundClip:"text", WebkitTextFillColor:"transparent", backgroundClip:"text"}}>Formulir Iuran Lainnya (Sukarela/Khusus)</div>
      <div style={{background:"rgba(255, 255, 255, 0.8)", backdropFilter:"blur(12px)", WebkitBackdropFilter:"blur(12px)", borderRadius:"16px", padding:"20px", boxShadow:"0 8px 24px rgba(30, 86, 49, 0.08)", border:"1px solid rgba(30, 86, 49, 0.08)", marginBottom:"24px"}}>
        <form onSubmit={handleSubmit}>
          <label style={{fontSize:"14px", fontWeight:"600", color:"#5A6059", display:"block", marginBottom:"6px"}}>Nama Warga:</label>
          <input style={{...styles.input, background:"rgba(248, 250, 246, 0.6)", color:"#8A8F86"}} className="futuristic-input" value={house.nama} disabled />
          <label style={{fontSize:"14px", fontWeight:"600", color:"#5A6059", display:"block", marginBottom:"6px"}}>Nomor Rumah:</label>
<input style={{...styles.input, background:"rgba(248, 250, 246, 0.6)", color:"#8A8F86"}} className="futuristic-input" value={house.nomor_rumah} disabled />

<label style={{fontSize:"14px", fontWeight:"600", color:"#5A6059", display:"block", marginBottom:"6px"}}>
Jenis Iuran:
</label>

<input
  style={styles.input}
  className="futuristic-input"
  type="text"
  placeholder="Contoh: Sumbangan Masjid"
  value={jenisIuran}
  onChange={(e)=>setJenisIuran(e.target.value)}
  required
/>

<label style={{fontSize:"14px", fontWeight:"600", color:"#5A6059", display:"block", marginBottom:"6px"}}>
Besar Iuran (Rp):
</label>

<input
  style={styles.input}
  className="futuristic-input"
  type="number"
  placeholder="Contoh: 50000"
  value={besarIuran}
  onChange={e=>setBesarIuran(e.target.value)}
  required
/>
          <label style={{fontSize:"14px", fontWeight:"600", color:"#5A6059", display:"block", marginBottom:"6px"}}>Unggah Bukti Transfer:</label>
          <input ref={fileInputRef} type="file" accept="image/*" onChange={handleUploadFile} style={{display:"none"}} />
          <button type="button" onClick={()=>fileInputRef.current && fileInputRef.current.click()} style={{...styles.btnGhost, marginTop:0, marginBottom:"14px", width:"100%"}} className="neon-btn">
            {uploading ? "Memproses..." : (buktiFoto ? "✓ Bukti Terpilih (Ganti)" : "📸 Pilih Gambar")}
          </button>
          <button type="submit" style={styles.btnPrimary} className="neon-btn">Upload bukti transfer</button>
        </form>
      </div>
      <div style={{display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:"10px"}}>
        <div style={{fontSize:"17px", fontWeight:"800", background:"linear-gradient(135deg, #1E5631 0%, #2E7D32 100%)", WebkitBackgroundClip:"text", WebkitTextFillColor:"transparent", backgroundClip:"text"}}>Riwayat & Status Verifikasi</div>
        <button
          type="button"
          onClick={muatRiwayatIuranLainnya}
          disabled={isRefreshing}
          style={{
            background: "linear-gradient(135deg, #1E5631 0%, #2E7D32 100%)",
            color: "#ffffff",
            border: "none",
            borderRadius: "10px",
            padding: "6px 12px",
            fontSize: "13px",
            fontWeight: "bold",
            cursor: isRefreshing ? "not-allowed" : "pointer",
            opacity: isRefreshing ? 0.7 : 1,
            boxShadow: "0 4px 12px rgba(30, 86, 49, 0.2)"
          }}
        >
          {isRefreshing ? "Memuat..." : "🔄 Refresh"}
        </button>
      </div>
      {riwayat.length === 0 ? (
        <div style={{textAlign:"center", color:"#8A8F86", padding:"20px", background:"rgba(255, 255, 255, 0.6)", borderRadius:"12px", border:"1px solid rgba(30, 86, 49, 0.08)"}}>Belum ada riwayat iuran lainnya.</div>
      ) : (
        riwayat.filter(item => !hiddenItems.includes(item.id)).map((item, idx) => (
          <div
            key={item.id || idx}
            style={{
              background:"rgba(255, 255, 255, 0.8)",
              backdropFilter:"blur(12px)",
              WebkitBackdropFilter:"blur(12px)",
              borderRadius:"16px",
              padding:"16px",
              marginBottom:"12px",
              boxShadow:"0 4px 16px rgba(30, 86, 49, 0.08)",
              border:"1px solid rgba(30, 86, 49, 0.08)",
              position:"relative"
            }}
          >
            <button
              type="button"
              onClick={() => hideItem(item.id)}
              aria-label="Hapus riwayat"
              style={{
                position:"absolute",
                top:"10px",
                right:"10px",
                background:"rgba(194, 76, 76, 0.1)",
                border:"1px solid rgba(194, 76, 76, 0.25)",
                color:"#C24C4C",
                width:"30px",
                height:"30px",
                borderRadius:"50%",
                cursor:"pointer",
                display:"flex",
                alignItems:"center",
                justifyContent:"center",
                transition:"all 0.2s ease"
              }}
              onMouseEnter={e => { e.currentTarget.style.background = "rgba(194, 76, 76, 0.2)"; e.currentTarget.style.transform = "scale(1.1)"; }}
              onMouseLeave={e => { e.currentTarget.style.background = "rgba(194, 76, 76, 0.1)"; e.currentTarget.style.transform = "scale(1)"; }}
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
        
            <div style={{
              fontWeight:"bold",
              fontSize:"16px",
              color:"#1E5631",
              marginBottom:"8px"
            }}>
              {item.jenis_iuran || "Iuran Lainnya"}
            </div>
        
            <div style={{
              fontSize:"15px",
              marginBottom:"6px",
              color:"#1E2A22"
            }}>
              💰 {formatRupiah(item.nominal || 0)}
            </div>
        
            <div style={{
              fontSize:"13px",
              color:"#8A8F86",
              marginBottom:"10px"
            }}>
              📅 {new Date(item.created_at).toLocaleDateString("id-ID")}
            </div>
        
            <div style={{marginBottom:"12px"}}>
              <StatusBadge status={item.status || "Menunggu verifikasi"} />
            </div>
        
            {item.bukti_transfer && (
              <a
                href={item.bukti_transfer}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color:"#1E5631",
                  fontWeight:"bold",
                  textDecoration:"none"
                }}
              >
                📷 Lihat Bukti Transfer
              </a>
            )}
        
          </div>
        ))
      )}
    </div>
  );
}

// ================= PERBAIKAN: MENAMPILKAN KEMBALI DAFTAR SATPAM UTALIS =================
function InformasiTab({ announcements }){
  return (
    <div>
      <div style={styles.badgeTrial}>⚠️ Tahap uji coba simulasi internal pengurus RT Pesona Ciputih.</div>
      
      {/* DIKEMBALIKAN: Panel Kontak Resmi Pos Keamanan / Satpam */}
      <div style={{...styles.infoBox, background:"rgba(37, 211, 102, 0.06)", borderLeft:"4px solid #25D366", boxShadow:"0 4px 16px rgba(30, 86, 49, 0.08)", marginBottom:"16px", border:"1px solid rgba(37, 211, 102, 0.15)", borderLeftWidth:"4px"}}>
        <div style={{fontWeight:"bold", color:"#128C7E", fontSize:"16px", marginBottom:"10px"}}>🚨 Hubungi Pos Keamanan (Security):</div>
        
        <div style={{display:"flex", justifyContent:"space-between", alignItems:"center", padding:"10px 0", borderBottom:"1px solid rgba(30, 86, 49, 0.08)"}}>
          <div>
            <div style={{fontWeight:"bold", fontSize:"15.5px", color:"#1E2A22"}}>Pak Ucup</div>
            <div style={{fontSize:"13.5px", color:"#8A8F86"}}>085892727736</div>
          </div>
          <a href="https://wa.me/6285892727736" target="_blank" rel="noopener noreferrer" style={styles.waButton}>🟢 CHAT WA</a>
        </div>
        
        <div style={{display:"flex", justifyContent:"space-between", alignItems:"center", padding:"10px 0", borderBottom:"1px solid rgba(30, 86, 49, 0.08)"}}>
          <div>
            <div style={{fontWeight:"bold", fontSize:"15.5px", color:"#1E2A22"}}>Pak Faisal</div>
            <div style={{fontSize:"13.5px", color:"#8A8F86"}}>089513959418</div>
          </div>
          <a href="https://wa.me/6289513959418" target="_blank" rel="noopener noreferrer" style={styles.waButton}>🟢 CHAT WA</a>
        </div>
        
        <div style={{display:"flex", justifyContent:"space-between", alignItems:"center", padding:"10px 0"}}>
          <div>
            <div style={{fontWeight:"bold", fontSize:"15.5px", color:"#1E2A22"}}>Pak Wawan</div>
            <div style={{fontSize:"13.5px", color:"#8A8F86"}}>085779225354</div>
          </div>
          <a href="https://wa.me/6285779225354" target="_blank" rel="noopener noreferrer" style={styles.waButton}>🟢 CHAT WA</a>
        </div>
      </div>

      <div style={{fontSize:"17px", fontWeight:"800", background:"linear-gradient(135deg, #1E5631 0%, #2E7D32 100%)", WebkitBackgroundClip:"text", WebkitTextFillColor:"transparent", backgroundClip:"text", marginBottom:"10px"}}>Pengumuman RT Terbaru:</div>
      {(!announcements || announcements.length === 0) ? (
        <div style={{textAlign:"center", color:"#8A8F86", padding:"20px", background:"rgba(255, 255, 255, 0.6)", borderRadius:"12px", border:"1px solid rgba(30, 86, 49, 0.08)"}}>Belum ada pengumuman terbaru.</div>
      ) : (
        announcements.map((a, i)=>(
          <div key={i} style={{background:"rgba(255, 255, 255, 0.8)", backdropFilter:"blur(12px)", WebkitBackdropFilter:"blur(12px)", borderRadius:"16px", padding:"18px", marginBottom:"12px", border:"1px solid rgba(30, 86, 49, 0.08)", boxShadow:"0 4px 16px rgba(30, 86, 49, 0.06)"}}>
            <div style={{fontSize:"16px", fontWeight:"bold", color:"#1E5631"}}>{a.judul}</div>
            <div style={{fontSize:"14px", whiteSpace:"pre-wrap", marginTop:"6px", color:"#1E2A22"}}>{a.isi}</div>
          </div>
        ))
      )}
    </div>
  );
}

function AboutTab() {
  return (
    <div style={{ paddingBottom: "20px" }}>
      <div style={{ background: "linear-gradient(135deg, rgba(30, 86, 49, 0.12) 0%, rgba(46, 125, 50, 0.12) 100%)", color: "#1E2A22", borderRadius: "20px", padding: "24px", marginBottom: "20px", boxShadow: "0 8px 32px rgba(30, 86, 49, 0.1)", border: "1px solid rgba(30, 86, 49, 0.15)", backdropFilter: "blur(12px)", WebkitBackdropFilter: "blur(12px)" }}>
        <div style={{ fontSize: "13px", color: "#1E5631", marginBottom: "6px", fontWeight: "600", letterSpacing: "0.5px" }}>TENTANG APLIKASI</div>
        <div style={{ fontSize: "22px", fontWeight: "800", marginTop: "4px", lineHeight: "1.3", background: "linear-gradient(135deg, #1E5631 0%, #2E7D32 100%)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", backgroundClip: "text" }}>About</div>
      </div>
      <div style={{ background: "rgba(255, 255, 255, 0.8)", backdropFilter: "blur(12px)", WebkitBackdropFilter: "blur(12px)", borderRadius: "16px", padding: "8px 20px", marginBottom: "18px", border: "1px solid rgba(30, 86, 49, 0.08)", borderLeft: "4px solid #1E5631" }}>
        <div style={styles.bioRow}>
          <span style={styles.bioLabel}>Versi</span>
          <span style={styles.bioVal}>1.0</span>
        </div>
        <div style={{ padding: "14px 0", borderBottom: "1px solid rgba(30, 86, 49, 0.08)", fontSize: "15px", color: "#1E2A22", lineHeight: "1.5" }}>
          Aplikasi IPL Pesona Ciputih ini hanya untuk kalangan sendiri, tidak untuk diperjual belikan.
        </div>
        <div style={styles.bioRow}>
          <span style={styles.bioLabel}>Pembuat</span>
          <span style={{ ...styles.bioVal, textAlign: "right" }}>
            Meikun Dwi Susanto<br />
            <span style={{ fontWeight: "normal", color: "#5A6059", fontSize: "14px" }}>081328208533</span>
          </span>
        </div>
      </div>
    </div>
  );
}

// ================= HALAMAN MENU UTAMA =================
function MenuTab({ house, onSelectMenu }) {
  const menuItems = [
    {
      key: "profil",
      icon: "🏠",
      title: "Profil",
      desc: "Data warga & informasi tarif",
      bg: "rgba(30, 86, 49, 0.06)",
      shadow: "rgba(30, 86, 49, 0.15)",
      text: "#1E5631"
    },
    {
      key: "pembayaran",
      icon: "💳",
      title: "Bayar IPL",
      desc: "Pembayaran iuran bulanan",
      bg: "rgba(46, 125, 50, 0.06)",
      shadow: "rgba(46, 125, 50, 0.15)",
      text: "#2E7D32"
    },
    {
      key: "iuran_lainnya",
      icon: "💰",
      title: "Iuran Lainnya",
      desc: "Iuran sukarela/khusus",
      bg: "rgba(245, 158, 11, 0.06)",
      shadow: "rgba(245, 158, 11, 0.15)",
      text: "#B45309"
    },
    {
      key: "laporan",
      icon: "✍️",
      title: "Laporan Warga",
      desc: "Masalah fasilitas dan lainnya",
      bg: "rgba(76, 175, 80, 0.06)",
      shadow: "rgba(76, 175, 80, 0.15)",
      text: "#4CAF50"
    },
    {
      key: "laporan_tunggakan",
      icon: "⚠️",
      title: "Laporan Tunggakan",
      desc: "Rumah dgn tunggakan > 3 bulan",
      bg: "rgba(194, 76, 76, 0.06)",
      shadow: "rgba(194, 76, 76, 0.15)",
      text: "#C24C4C"
    },
    {
      key: "informasi",
      icon: "📋",
      title: "Informasi",
      desc: "Pengumuman & kontak pos",
      bg: "rgba(30, 86, 49, 0.06)",
      shadow: "rgba(30, 86, 49, 0.15)",
      text: "#1E5631"
    },
    {
      key: "about",
      icon: "ℹ️",
      title: "About",
      desc: "Informasi aplikasi",
      bg: "rgba(30, 86, 49, 0.06)",
      shadow: "rgba(30, 86, 49, 0.15)",
      text: "#1E5631"
    }
  ];

  return (
    <div style={{ paddingBottom: "20px" }}>
      <div style={{ background: "linear-gradient(135deg, rgba(30, 86, 49, 0.12) 0%, rgba(46, 125, 50, 0.12) 100%)", color: "#1E2A22", borderRadius: "20px", padding: "24px", marginBottom: "20px", boxShadow: "0 8px 32px rgba(30, 86, 49, 0.1)", border: "1px solid rgba(30, 86, 49, 0.15)", backdropFilter: "blur(12px)", WebkitBackdropFilter: "blur(12px)" }}>
        <div style={{ fontSize: "13px", color: "#1E5631", marginBottom: "6px", fontWeight: "600", letterSpacing: "0.5px" }}>SELAMAT DATANG</div>
        <div style={{ fontSize: "22px", fontWeight: "800", marginTop: "4px", lineHeight: "1.3", background: "linear-gradient(135deg, #1E5631 0%, #2E7D32 100%)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", backgroundClip: "text" }}>Bpk/Ibu {house.nama}</div>
        <div style={{ fontSize: "15px", marginTop: "8px", color: "#5A6059" }}>Nomor rumah: <strong style={{color:"#1E2A22"}}>{house.nomor_rumah}</strong></div>
      </div>

      <div style={{ fontSize: "17px", fontWeight: "800", background: "linear-gradient(135deg, #1E5631 0%, #2E7D32 100%)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", backgroundClip: "text", marginBottom: "14px" }}>Pilih Menu:</div>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "14px" }}>
        {menuItems.map((item) => (
          <button
            key={item.key}
            type="button"
            onClick={() => onSelectMenu(item.key)}
            className="neon-btn"
            style={{
              ...styles.btn3D(item.bg, item.shadow, item.text),
              textAlign: "left",
              padding: "18px 14px",
              minHeight: "120px"
            }}
          >
            <div style={{ fontSize: "32px", marginBottom: "8px" }}>{item.icon}</div>
            <div style={{ fontSize: "16px", fontWeight: "bold", marginBottom: "4px" }}>{item.title}</div>
            <div style={{ fontSize: "12.5px", opacity: 0.85, lineHeight: "1.3" }}>{item.desc}</div>
          </button>
        ))}
      </div>

      <div style={{ marginTop: "14px", textAlign: "center", fontSize: "13px", color: "#8A8F86" }}>
        IPL Pesona Ciputih
      </div>
    </div>
  );
}

function WargaApp({ house, onLogout, onRequestChangePassword }) {
  const [tab, setTab] = useState("menu");
  const [listPembayaranSupabase, setListPembayaranSupabase] = useState([]);
  const [announcements, setAnnouncements] = useState([]);
  const [currentHouseData, setCurrentHouseHouseData] = useState(house);

  const muatPembayaranTerbaruWarga = useCallback(async () => {
    try {
      const { data, error } = await supabase
        .from("pembayaran")
        .select("*")
        .eq("nomor_rumah", currentHouseData?.nomor_rumah);
      if (!error) {
        setListPembayaranSupabase(data || []);
      }
    } catch (err) { console.error(err); }
  }, [currentHouseData?.nomor_rumah]);

  const muatPengumuman = useCallback(async () => {
    try {
      const { data, error } = await supabase
        .from("pengumuman")
        .select("*")
        .order("created_at", { ascending: false });

      if (!error) {
        setAnnouncements(data || []);
      }
    } catch (err) { console.error(err); }
  }, []);

  useEffect(() => {
    muatPembayaranTerbaruWarga();
    muatPengumuman();

    const targetHouse = normalizeHouseNo(currentHouseData?.nomor_rumah);
    if (!targetHouse) return undefined;

    const pembayaranChannel = supabase
      .channel(`pembayaran-${targetHouse}`)
      .on(
        "postgres_changes",
        { event: "*", schema: "public", table: "pembayaran" },
        (payload) => {
          if (isPaymentRecordForHouse(payload, targetHouse)) {
            muatPembayaranTerbaruWarga();
          }
        }
      )
      .subscribe();

    const pengumumanChannel = supabase
      .channel("pengumuman-updates")
      .on(
        "postgres_changes",
        { event: "*", schema: "public", table: "pengumuman" },
        () => {
          muatPengumuman();
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(pembayaranChannel);
      supabase.removeChannel(pengumumanChannel);
    };
  }, [currentHouseData?.nomor_rumah, muatPembayaranTerbaruWarga, muatPengumuman]);

  return (
    <div style={styles.app}>
      <div style={styles.header}>
        <div style={{display:"flex", justifyContent:"space-between", alignItems:"center"}}>
          <div style={{display:"flex", alignItems:"center", gap:"12px"}}>
            {tab !== "menu" && (
              <button type="button" onClick={() => setTab("menu")} style={{background:"rgba(30, 86, 49, 0.08)", border:"1px solid rgba(30, 86, 49, 0.15)", color:"#1E5631", width:"40px", height:"40px", borderRadius:"50%", cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", transition:"all 0.3s ease"}}>
                {/* DIKUNCI: Ikon grafis panah asli tebal */}
                <IconPanahBackSVG />
              </button>
            )}
            <div>
              <div style={{fontSize:"17px", fontWeight:"800", background:"linear-gradient(135deg, #1E5631 0%, #2E7D32 100%)", WebkitBackgroundClip:"text", WebkitTextFillColor:"transparent", backgroundClip:"text"}}>IPL Pesona Ciputih</div>
              <div style={{fontSize:"13.5px", color:"#8A8F86"}}>{currentHouseData.nomor_rumah} · {currentHouseData.nama}</div>
            </div>
          </div>
          <button type="button" onClick={onLogout} style={{background:"rgba(194, 76, 76, 0.08)", border:"1px solid rgba(194, 76, 76, 0.25)", color:"#C24C4C", padding:"8px 14px", borderRadius:"10px", fontSize:"13.5px", fontWeight:"bold", cursor:"pointer", transition:"all 0.3s ease"}}>Keluar</button>
        </div>
      </div>
      
      <div style={styles.content}>
        {tab === "menu" && <MenuTab house={currentHouseData} onSelectMenu={(key)=>setTab(key)} />}
        {tab === "profil" && <ProfilTab house={currentHouseData} onUpdateProfil={async (n,h)=>{}} onRequestChangePassword={onRequestChangePassword} />}
        {tab === "pembayaran" && <PembayaranTab house={currentHouseData} listPembayaranSupabase={listPembayaranSupabase} refreshPayData={muatPembayaranTerbaruWarga} />}
        {tab === "iuran_lainnya" && <IuranLainnyaTab house={currentHouseData} />}
        {tab === "laporan" && (
  <LaporanTab
    supabase={supabase}
    house={currentHouseData}
    styles={styles}
    StatusBadge={StatusBadge}
  />
)}
        {tab === "laporan_tunggakan" && <LaporanTunggakanTab />}
        {tab === "informasi" && <InformasiTab announcements={announcements} />}
        {tab === "about" && <AboutTab />}
      </div>
    </div>
  );
}

export default function App(){
  const [booted, setBooted] = useState(false);
  const [session, setSession] = useState(null);
  const [mustChangePassword, setMustChangePassword] = useState(false);
  const [error, setError] = useState("");

  useEffect(()=>{
    sget("houses_list").then(houses=>{
      if(!houses){ sset("houses_list", RAW_HOUSES); }
      setBooted(true);
    });
  }, []);

  const loginWarga = async (houseNoRaw, pass) => {
    try {
      setError("");

      const houseNo = String(houseNoRaw || "").trim().toUpperCase();
      if (!houseNo) {
        setError("Masukkan nomor rumah.");
        return;
      }

      // Hapus filter .eq("aktif", true) dari query karena bisa menyebabkan
      // baris tidak ditemukan jika kolom aktif bernilai null/false/bukan
      // boolean true. Cek aktif di kode saja agar lebih toleran.
      const { data, error } = await supabase
        .from("warga")
        .select("*")
        .eq("nomor_rumah", houseNo)
        .maybeSingle();

      const defaultResident = buildResidentFromDefaultData(houseNo);

      if (error && error.code !== "PGRST116") {
        console.error(error);
        setError("Gagal memeriksa data warga.");
        return;
      }

      // Cek apakah warga non-aktif (jika data ada tapi aktif=false/null)
      if (data && data.aktif === false) {
        setError("Akun warga ini tidak aktif. Hubungi pengurus RT.");
        return;
      }

      const residentData = data || defaultResident;

      if (!residentData) {
        setError("Nomor rumah tidak ditemukan.");
        return;
      }

      // Prioritas PIN:
      // 1. PIN dari tabel warga_password (tabel khusus, RLS terbuka)
      // 2. PIN dari tabel warga (legacy/fallback)
      // 3. PIN dari cache lokal (fallback jika Supabase bermasalah)
      // 4. PIN default = nomor rumah
      const legacyPin = String(data?.pin ?? "").trim();
      const cachedPin = await getCachedPin(houseNo);
      const defaultPin = String(residentData.nomor_rumah || "").trim();

      // Baca PIN dari tabel warga_password (tabel baru yang RLS-nya terbuka)
      let newPasswordPin = "";
      try {
        const { data: pwdRow, error: pwdErr } = await supabase
          .from("warga_password")
          .select("pin")
          .eq("nomor_rumah", houseNo)
          .maybeSingle();
        if (!pwdErr && pwdRow) {
          newPasswordPin = String(pwdRow.pin ?? "").trim();
        }
      } catch (e) {
        console.warn("Gagal baca dari warga_password:", e);
      }

      let expectedPin;
      if (newPasswordPin && newPasswordPin !== defaultPin) {
        // Tabel warga_password punya PIN custom -> gunakan itu (prioritas utama)
        expectedPin = newPasswordPin;
      } else if (legacyPin && legacyPin !== defaultPin) {
        // Fallback: tabel warga lama punya PIN custom
        expectedPin = legacyPin;
      } else if (cachedPin && cachedPin !== defaultPin) {
        // Fallback: cache lokal punya PIN custom
        expectedPin = cachedPin;
      } else {
        // Fallback ke default (nomor rumah)
        expectedPin = newPasswordPin || legacyPin || cachedPin || defaultPin;
      }

      if (expectedPin !== String(pass || "").trim()) {
        setError("PIN salah.");
        return;
      }

      setSession({
        type: "warga",
        house: {
          nomor_rumah: residentData.nomor_rumah,
          nama: residentData.nama,
          no_hp: residentData.no_hp || ""
        }
      });

      // Wajib ganti password jika masih pakai default (nomor rumah)
      if (expectedPin === defaultPin) {
        setMustChangePassword(true);
      } else {
        setMustChangePassword(false);
      }

    } catch (err) {
      console.error(err);
      setError("Gagal login.");
    }
  };

  const changePasswordForCurrent = async (newPin) => {
    if (!session || !session.house) {
      alert('Gagal memperbarui password: Tidak ada sesi aktif.');
      return;
    }
    const nomor = session.house.nomor_rumah;
    const pinTrimmed = String(newPin).trim();

    let supabaseOk = false;
    let supabaseErrMsg = "";

    try {
      // === SIMPAN KE TABEL warga_password (tabel baru, RLS terbuka) ===
      // Cek apakah sudah ada row untuk nomor rumah ini
      const { data: existingPwd, error: checkPwdError } = await supabase
        .from('warga_password')
        .select('id')
        .eq('nomor_rumah', nomor)
        .maybeSingle();

      if (checkPwdError && checkPwdError.code !== "PGRST116") {
        console.warn('Cek warga_password:', checkPwdError);
      }

      if (existingPwd) {
        // Sudah ada row -> UPDATE pin
        const { error: updatePwdError } = await supabase
          .from('warga_password')
          .update({ pin: pinTrimmed })
          .eq('nomor_rumah', nomor);
        if (updatePwdError) throw updatePwdError;
        supabaseOk = true;
      } else {
        // Belum ada row -> INSERT row baru
        const { error: insertPwdError } = await supabase
          .from('warga_password')
          .insert([{
            nomor_rumah: nomor,
            pin: pinTrimmed
          }]);
        if (insertPwdError) throw insertPwdError;
        supabaseOk = true;
      }

      // Verifikasi: baca kembali pin dari warga_password untuk memastikan tersimpan
      if (supabaseOk) {
        const { data: verify, error: verifyErr } = await supabase
          .from('warga_password')
          .select('pin')
          .eq('nomor_rumah', nomor)
          .maybeSingle();
        if (verifyErr && verifyErr.code !== "PGRST116") {
          console.warn('Verifikasi gagal (tidak fatal):', verifyErr);
        }
        if (verify && String(verify.pin ?? "").trim() === pinTrimmed) {
          // Tersimpan & terbaca di Supabase
        } else {
          console.warn('PIN tidak terbaca kembali dari warga_password.');
        }
      }

      // === JUGA UPDATE TABEL warga (legacy, sebagai backup) ===
      // Tetap simpan ke tabel warga jika memungkinkan, tapi kegagalan
      // di sini tidak fatal karena warga_password sudah sukses.
      try {
        const { data: existingWarga } = await supabase
          .from('warga')
          .select('nomor_rumah')
          .eq('nomor_rumah', nomor)
          .maybeSingle();

        if (existingWarga) {
          await supabase
            .from('warga')
            .update({ pin: pinTrimmed, aktif: true })
            .eq('nomor_rumah', nomor);
        } else {
          await supabase
            .from('warga')
            .insert([{
              nomor_rumah: nomor,
              nama: session.house.nama || "",
              no_hp: session.house.no_hp || "",
              pin: pinTrimmed,
              aktif: true
            }]);
        }
      } catch (legacyErr) {
        // Kegagalan update tabel warga tidak fatal, warga_password sudah sukses
        console.warn('Update tabel warga (legacy) gagal, tapi warga_password sukses:', legacyErr);
      }
    } catch (err) {
      console.error('Supabase error saat ganti password:', err);
      supabaseErrMsg = err.message || String(err);
    }

    // SELALU simpan ke cache lokal sebagai fallback tambahan
    try {
      await setCachedPin(nomor, pinTrimmed);
    } catch (e) {
      console.error('Gagal simpan cache PIN lokal:', e);
    }

    if (supabaseOk) {
      setMustChangePassword(false);
      alert('Password berhasil diperbarui.');
    } else {
      // Supabase gagal, tapi cache lokal sudah disimpan -> password
      // baru tetap bisa dipakai di perangkat ini.
      setMustChangePassword(false);
      alert('Password berhasil diperbarui di perangkat ini. (Catatan: server bermasalah - ' + supabaseErrMsg + ')');
    }
  };

  if(!booted) return <div style={styles.centerScreen}><div style={{color:"#1E5631"}}>Memuat...</div></div>;
  if(!session) return <LoginScreen onLoginWarga={loginWarga} error={error} />;

  if (session && mustChangePassword) {
    return <ChangePasswordScreen onChange={changePasswordForCurrent} />;
  }

  return <WargaApp house={session.house} onLogout={()=>{ setSession(null); setMustChangePassword(false); }} onRequestChangePassword={()=>setMustChangePassword(true)} />;
}